<template >
  <div style=" height: 100vh;">
      <div class="houseSet_Two">
        <ul class="nav">
          <li
              v-for="item in tabs"
              :key="item.code"
              :class="typeTab === item.code ? 'active' : ''"
              @click="typeTab = item.code"
          >{{ item.name }}</li>
        </ul>

      </div>
      <div class="houseSet_three">
        <ul class="collapseClass" >
          <template v-for="item in tabs">
            <li :key="item.code" v-show="typeTab === item.code">
              <el-collapse :value="item.list.map(i => i.code)">
                <el-collapse-item
                    v-for="group in item.list"
                    :title="group.name"
                    :name="group.code"
                    :key="group.code"
                >
                  <ul class="input-list" >
                      <el-checkbox-group v-model="checkOne" class="checkGroup" id="checkboxList1" @change="changeOn">
                            <el-checkbox  v-for="num in group.list"
                                          :label="num.name"
                                          :key="num.code"   >
                              {{num.name}}
                            </el-checkbox>
                       </el-checkbox-group>
                  </ul>
                </el-collapse-item>
              </el-collapse>
            </li>
          </template>
        </ul>

      </div>
    <div class="footer_buten">
      <button class="save" @click="saveCheck" >保存</button>
    </div>
  </div>
</template>
<script>
import {updateCheckstatusByCodes} from "@/api/systemSetup";
export default {
  name: "houseSet",
  props: {
    tabs: {
      type: Array,
      default: () => []
    },
  },
  watch: {
    tabs(newVal) {
      if (!newVal) {
        return
      }
      const item = newVal[0] || {}
      if(this.codeHouse != 1){
        this.typeTab = this.codeHouse
      }else {
        this.typeTab = item.code
      }
    },
    typeTab(oldVal,newVal){
      this.changeChecked(this.tabs,oldVal)
    }
  },
  components: {  },
  data(){
    let permisList = JSON.parse(sessionStorage.getItem("permisList"));
    return {
      typeTab: '1',
      permisList,
      chooseData:[],//一级目录
      secondData:[{list:[]},{list:[]}],//二级目录
      checkedIndex:"0",//选中的下标基础设置等
      checkHouseIndex:"0",//选中的二手房等
      codeHouse:'',//code
      checkOne:[],//选中的多选框
      checkedName:"",//选中的数据（基础设置等）
    }
  },
  mounted() {

  },
  methods:{

    getTitleList(datas){
      this.changeChecked(datas,this.typeTab)
    },
    //是否选中
    changeOn(value){
      this.checkOne  = value
    },

    //处里初始化选中数据
    changeChecked(res,code){
      this.checkOne = []
      this.codeHouse =code //当前选中coed值
      for (let i = 0; i < res.length; i++) {
        if(res[i].code == code){
          for (let j = 0; j <res[i].list.length ; j++) {
            if( res[i].list[j].list){
              for (let k = 0; k < res[i].list[j].list.length; k++) {
                if(res[i].list[j].list[k].checkstatus == "1"){
                  this.checkOne.push(res[i].list[j].list[k].name)
                }
              }
            }
          }
        }
      }
    },



    permisShow(data) {
      // 权限配置
      let result = this.permisList.indexOf(data);
      if (result >= 0) {
        return true;
      } else {
        return false;
      }
    },
    //点击保存按钮
    saveCheck(){
      let params = {}
      params.pcode = this.codeHouse
      //获取value值
      let code = []
      let codeAll = []
      for (let i = 0;i<this.tabs.length;i++){
        if(this.tabs[i].code == this.codeHouse){
          codeAll = this.tabs[i].list
        }
      }
      for (let i = 0; i < codeAll.length; i++) {
        for (let j = 0; j <codeAll[i].list.length ; j++) {
          if(this.checkOne.indexOf(codeAll[i].list[j].name)!== -1){
            code.push(codeAll[i].list[j].code)
          }
        }
      }
      params.codes = code
      this.$post(updateCheckstatusByCodes,params).then((res)=>{
        if (res.success) {
          this.$message({
            message: res.msg,
            type: "success",
          });
          if(this.codeHouse.slice(0,2)=="02"){
            this.$emit("chooseShowLoad",1,{description:'02',functionName:'纠错设置'})
          }else {
            this.$emit("chooseShowLoad",1,{description:'07',functionName:'纠错设置'})
          }
        }else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      })

    },
  }
}
</script>

<style lang='less' scoped>
.pColor1{
  color:#5E75E6;
}
.pColor2{
  color:#303133;
}
.collapseClass/deep/.el-collapse-item__header{

  font-size: 16px;
  font-family: Microsoft YaHei ;
  font-weight: 600;
  color:#303133;
  margin-left: 40px;
}
.collapseClass/deep/.el-collapse-item__content {
    margin-left: 40px;
}


  .input-list {
  display: flex;
  flex-wrap: wrap;
    width: 75%;
  li {
    width: 130px;
    margin: 0 20px 20px 0;
    .lable {
      display: inline-block;
      width: 70px;
      text-align: left;
      padding-left: 1em;
      box-sizing: border-box;
    }
    .el-input-number {
      width: 90px;
    }
  }
}
.houseSet_Two{
  cursor:pointer;
  height: 35px;
  background: #EFF2FF;
  margin-right: 39px;
  position:relative;
  font-size: 14px;
  .nav {
    background: #EFF2FF;
    display: flex;
    position: relative;
    margin: 0;
    li {
      cursor: pointer;
      height: 35px;
      line-height: 35px;
      padding: 0 30px;
    }
  }
  .content {
    padding: 20px;
    width: 100px;
  }
}
.houseSetTwo_title{
  height: 15px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #303133;
  margin-left: 23px;
  margin-top: 10px;
  //line-height: 42px;
}
.houseSetTwo_title2{
  height: 15px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #303133;
  margin-left: 60px;
  margin-top: 10px;
}

.houseSet_switch{
  position:absolute; right:10px; top:7px;
}
.el-switch__core {
  height: 23px;
  border-radius: 12px;
}
.el-switch__core::after { width: 15px; height: 15px;background: #FFFFFF;
  border-radius: 50%;margin-top: 2px }

.houseSet_three{
  margin-right: 39px;
  background: #FFFFFF;
  border: 1px solid #F0F0F0;
  overflow: hidden;
  .nav {
    background: #EFF2FF;
    display: flex;
    position: relative;
    margin: 0;
    li {
      cursor: pointer;
      height: 35px;
      line-height: 35px;
      padding: 0 30px;
    }

  }

}

.houseSet_three_one{
  margin-top: 34px;
}
.premises_span{
  width: 64px;
  height: 17px;
  font-size: 16px;
  font-family: Microsoft YaHei ;
  font-weight: 600;
  color:#303133;
  margin-left: 40px;
  //line-height: 42px;
}
.houseSet_three_two{
  margin-top: 24px;
  margin-left: 24px;
  width: 68%;
}
.houseSet_three_three{
  margin-top: 32px;
}
.houseSet_three_four{
  margin-top: 23px;
  margin-left: 24px;
  width: 68%;
}
#checkboxList .el-checkbox{
  width: 102px;
}
#checkboxList .el-checkbox__inner{
  width: 18px;
  height: 18px;
  border: 1px solid #DCDFE6;
  border-radius: 2px;
}
#checkboxList .el-checkbox__inner::after{
  height: 8px;
  left: 5px;
}
#checkboxList1 .el-checkbox{
  width: 102px;
}
#checkboxList1 .el-checkbox__inner{
  width: 18px;
  height: 18px;
  border: 1px solid #DCDFE6;
  border-radius: 2px;
}
#checkboxList1 .el-checkbox__inner::after{
  height: 8px;
  left: 5px;
}
.footer_buten{
  font-size: 16px;
  color: white;
  border: none;
  outline: none;
  border-radius: 4px;
  margin-top: 40px;
  float: right;
  margin-right: 39px;
  font-weight: 400;
  &.save {
    width: 100px;
    height: 40px;
    background: #5E75E6;
    border-radius: 4px;
  }
}
.checkGroup{
  //margin-left: 84px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
}


</style>